/* eslint-disable */
import axios from 'axios';
import { API_CONFIG } from 'constants/config';
import React, { createContext, useContext, useEffect, useState } from 'react';


const CountRottingLeadsContext = createContext(undefined);

export const CountRottingLeads = ({ children }) => { 
  const [count, setCount] = useState(null);

  const fetchCount = async () => {
    try{
        const response = await axios.get(`${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}opportunities/rotting-stats/`, {  withCredentials: true });
        console.log(response)
        const value = response?.data?.number_of_rotting_opportunities || null
        setCount(value);
    }catch{
        setCount(null);
    }
  };

  useEffect(() => {
    fetchCount();
  }, []);
  
  return (
    <CountRottingLeadsContext.Provider value={{ count, fetchCount }}>
      {children}
    </CountRottingLeadsContext.Provider>
  );
};

export const useCountContextCountRotting = () => {
  const context = useContext(CountRottingLeadsContext);
  if (!context) {
    throw new Error('useCount must be used within a CountProvider');
  }
  return context;
};
